export const getIconNameForUrl = (url) => {
  if (!url) return null

  if (url.startsWith('tel:')) return 'phone'

  if (url.startsWith('mailto:')) return 'email'

  return 'external-link'
}
